/**
 * Capira Features — assets/capira-features.js
 */
(function () {
  'use strict';
  const pref    = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const section = document.getElementById('capira-features');
  if (!section) return;

  function observe(target, cb, opts) {
    if (pref) { cb(); return; }
    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) { cb(); io.disconnect(); }
    }, opts || { threshold: 0.10 });
    io.observe(target);
  }

  const header     = section.querySelector('.capira-feat__header') || section;
  const headerRule = section.querySelector('.capira-feat__header-rule');
  const revealEls  = section.querySelectorAll('[data-feat-reveal]');

  observe(header, () => {
    revealEls.forEach(el => {
      const d = parseInt(el.dataset.featRevealDelay || '0', 10);
      setTimeout(() => el.classList.add('is-visible'), d);
    });
    if (headerRule) setTimeout(() => headerRule.classList.add('is-visible'), 100);
  }, { threshold: 0.08 });

  const row1 = section.querySelector('.capira-feat-card--ai');
  if (row1) {
    observe(row1, () => {
      ['--ai', '--wealth'].forEach((s, i) => {
        const c = section.querySelector('.capira-feat-card' + s);
        if (c) setTimeout(() => c.classList.add('is-visible'), pref ? 0 : i * 100);
      });
    }, { threshold: 0.06 });
  }

  const row2 = section.querySelector('.capira-feat-card--tax');
  if (row2) {
    observe(row2, () => {
      ['--tax', '--debt', '--goals'].forEach((s, i) => {
        const c = section.querySelector('.capira-feat-card' + s);
        if (c) setTimeout(() => c.classList.add('is-visible'), pref ? 0 : i * 90);
      });
    }, { threshold: 0.06 });
  }

  const strip = section.querySelector('.capira-feat-card--strip');
  if (strip) {
    observe(strip, () => {
      setTimeout(() => strip.classList.add('is-visible'), pref ? 0 : 60);
    }, { threshold: 0.06 });
  }

  const wealthEl = section.querySelector('[data-wealth-count]');
  if (wealthEl) {
    const target = parseInt(wealthEl.dataset.wealthCount, 10);
    const card   = wealthEl.closest('.capira-feat-card');
    if (card) {
      const mo = new MutationObserver(mutations => {
        mutations.forEach(m => {
          if (!m.target.classList.contains('is-visible')) return;
          mo.disconnect();
          if (pref) { wealthEl.textContent = '$' + target.toLocaleString('en-US'); return; }
          const dur = 1600, t0 = performance.now();
          (function tick(now) {
            const p = Math.min((now - t0) / dur, 1);
            const e = 1 - Math.pow(1 - p, 4);
            wealthEl.textContent = '$' + Math.round(e * target).toLocaleString('en-US');
            if (p < 1) requestAnimationFrame(tick);
          })(performance.now());
        });
      });
      mo.observe(card, { attributes: true, attributeFilter: ['class'] });
    }
  }

  const taxArc = section.querySelector('.capira-feat-tax__arc');
  if (taxArc) {
    const arcTarget = parseFloat(taxArc.dataset.arc || '113');
    if (pref) {
      taxArc.style.transition = 'none';
      taxArc.style.strokeDashoffset = 150.8 - arcTarget;
    } else {
      const taxCard = taxArc.closest('.capira-feat-card');
      if (taxCard) {
        const mo = new MutationObserver(mutations => {
          mutations.forEach(m => {
            if (!m.target.classList.contains('is-visible')) return;
            taxArc.style.strokeDashoffset = 150.8 - arcTarget;
            mo.disconnect();
          });
        });
        mo.observe(taxCard, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      if (!e.target.contains(section)) return;
      revealEls.forEach(el => el.classList.add('is-visible'));
      if (headerRule) headerRule.classList.add('is-visible');
      section.querySelectorAll('.capira-feat-card').forEach(c => c.classList.add('is-visible'));
      if (wealthEl) wealthEl.textContent = '$' + parseInt(wealthEl.dataset.wealthCount, 10).toLocaleString('en-US');
      if (taxArc) taxArc.style.strokeDashoffset = 150.8 - parseFloat(taxArc.dataset.arc || '113');
    });
  }

})();
